import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Face Enhancer B";

const callFaceEnhancerB = async (
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
				},
				tool_document_id,
				jwt,
			};
			return fetchFaceEnhancerB(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchFaceEnhancerB(
	params: {
		inputs: {
			$img: string;
		};
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenFaceEnhancerBMessage() {
	useListenFromRenderer([
		{
			key: "faceEnhancerB",
			onMessage: async (message) => {
				const success = await callFaceEnhancerB(
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
